export default function useFormatterHelper(filters) {
  function formatNotice(noticeI18nObject, amount) {
    const formattedAmount = filters.currencySymbol(filters.currency(amount));
    return filters.translateI18nObject(noticeI18nObject).replace('{amount}', formattedAmount);
  }

  return { formatNotice };
}
